/**
 * Created by mauget on 2/1/16.
 */

import Immutable        from 'immutable';
import defaultTheme     from 'defaultTheme.js';
import listService      from 'ListService';
import textUtil             from 'util/TextUtil';
import constants        from "Constants.js";

//========================================================================================
// A singleton instance of this class exposes a mutable copy of master theme object.
// Lou Mauget, Groundhog Day minus 1, 2016
//========================================================================================
class ThemeService {

    constructor() {
        this.reset();
        this.defaultThemeValues = defaultTheme.toObject();
    }

    get theme() { return this._theme; }

    //=====================================================================
    // Returns value of presumed theme item key. Returns the key itself if
    // no value found for the key.
    //=====================================================================
    resolve( key ){
        // Just return the conditional resolved property or key if not resolved;

        // let val = key;
        // if (this.isThemeProperty(key)) {
        //     val = this.theme[ key ];
        // }
        // return key;

        if(this.isThemeProperty(key) &&
          (key.toLowerCase().includes('color') || key === '~groupTitleBg') &&
          this.theme[key].length < 6){
          this.theme[key] = this.fillHexNumber(key);
        }
        return this.isThemeProperty(key) ? this.theme[ key ] : key;
    }

    fillHexNumber(key){
        let valueToFill=this.theme[key];
        let numbersToFill= 6 - valueToFill.length;
        let i = 0;
        let filledHexNumber="#";
        while(i < numbersToFill){
            filledHexNumber +='0';
            i++;
        }
        return filledHexNumber + valueToFill;
    }


     //=====================================================================
     // Returns value of presumed default theme item key. Returns the default value 
     // in case the value does not exist in the model itself.
     //=====================================================================

    resolveDefaultThemeValue(key) {
        let propValue = this.theme[ key ];

        if (!propValue) {
            propValue = this.defaultThemeValues[key];
        }

        return propValue;
    }

    //=====================================================================
    // Move this singleton to its just-loaded state.
    //=====================================================================
    reset() {
        // A mutable clone of master.
        // The form theme property UI can modify a value.
        // We hape for no item creation, or deletion, however. :-(
        this._theme = defaultTheme.toObject();
    }

    //=====================================================================
    // Overrides a theme key,value pair. Watch the order of key and value.
    //=====================================================================
    updateItem( propValue, propName ) {
        this.theme[propName] = propValue;
    }

    logAll() {
        Immutable.Map(this.theme).map( (v, k) => {
            console.log(`\t${k}: ${v}`);
        });
    }

    normalizedThemeArray(base) {
        const propArray = this.resolve(base).split(',');
        const result = [];
        if (propArray[0]) {
            result[0] = propArray[0].trim();
        } else {
            result[0] = 'arial';
        }
        if (propArray[1]) {
            result[1] = propArray[1].trim();
        } else {
            result[1] = '10';
        }
        if ((propArray[2] && propArray[2].toLowerCase().indexOf('bold') > -1)
            || (propArray[3] && propArray[3].toLowerCase().indexOf('bold') > -1)) {
            result[2] = 'bold'
        } else {
            result[2] = 'normal';
        }
        if ((propArray[2] && propArray[2].toLowerCase().indexOf('italic') > -1)
            || (propArray[3] && propArray[3].toLowerCase().indexOf('italic') > -1)) {
            result[3] = 'italic'
        } else {
            result[3] = 'normal';
        }
        return result;
    }

    getValueFromTheme(base, prop) {
        var propArray = this.normalizedThemeArray(base);
        switch (prop) {
            case 'fontFamily':
            case 'headerFontFamily':
                return propArray[0].trim();
            case 'fontSize':
            case 'headerFontSize':
                return propArray[1].trim();
            case 'textWeight':
            case 'headerTextWeight':
                return propArray[2].trim();
            case 'textStyle':
            case 'headerTextStyle':
                return propArray[3].trim();
            default:
                break;
        }
        // So we never hit the default? This returns undefined if so.
    }

    isThemeProperty(val) {
        return val && typeof val === 'string' && val.length > 0 && val.charAt(0) === '~';
    }

    resolveThemeFont(prop, val) {
        return this.isThemeProperty(val) ? this.getValueFromTheme(val, prop) : val;
    }

    resolveThemeBorder(prop, val) {
        return this.isThemeProperty(val) ? this.getBorderValueFromTheme(val, prop) : val;
    }

    resolveThemeHeaderFont(prop, val) {
        return this.isThemeProperty(val) ? this.getValueFromTheme(val, prop) : val;
    }

    getBorderValueFromTheme(base, prop) {
        const propArray = this.resolve(base).split(',');
        if (propArray.length > 1) {
            switch (prop) {
                case 'borderSize':
                    return propArray[0].trim();
                case 'borderStyle':
                    return propArray[1].trim();
                case 'cornerRadius':
                    return propArray[2]? propArray[2].trim() : '0';
                default:
                    break;
            }
        } else {
            return this.resolve(base)
        }
        // TODO: it returns undefined  here if nothing hits above - Lou Mauget 26-April-16

    }

    resolveHeaderFontProps(props) {
        props.headerTextColor = this.resolve(props.headerTextColor);
        props.styleHeaderColorText = this.resolve(props.styleHeaderColorText);
        props.headerFont = this.resolve(props.headerFont);
        props.headerFontFamily = this.resolveThemeFont('headerFontFamily', props.headerFontFamily);
        props.headerFontSize = this.resolveThemeFont('headerFontSize', props.headerFontSize);
        props.headerTextWeight = this.resolveThemeFont('headerTextWeight', props.headerTextWeight);
        props.headerTextStyle = this.resolveThemeFont('headerTextStyle', props.headerTextStyle);
    }

    updateTextObjectsFontChanged(factoryKey) {

        //find all objects with this key, and run them through the logic to update their size based on Font.
        const filter = (control) => {
            return (
                control.model.get('factoryKey') === factoryKey
            );
        };
        const objects = listService.getFilteredControls(filter);

        objects.map(obj => {
            textUtil.updateTextContent(obj.model, true, {silent:true});
            obj.render();
        });


    }

    updateInputObjectsFontChanged() {

        //find all objects with this key, and run them through the logic to update their size based on Font.
        const filter = (control) => {
            return (
                (control.family === constants.CONTROL_COMMON_INPUTS || control.family === constants.CONTROL_ADVANCED_INPUTS)
            );
        };
        const objects = listService.getFilteredControls(filter);

        objects.map(obj => {
            textUtil.updateTextContent(obj.model, true, {silent:true});
            obj.render();
        });
    }


    deattachTheme(control) {
        switch (control.model.get('factoryKey')) {
            case 'page_instance':
            case 'layout_page':
            case 'report_page':
                this.deattachPage(control);
                break;
            case 'control_text':
            case 'control_bullet_text':
            case 'control_small_text':
            case 'control_large_heading':
            case 'control_medium_heading':
            case 'control_small_heading':
            case 'control_link':
                this.deattachText(control);
                break;
            case 'control_text_input':
            case 'control_multiple_text_input':
            case 'control_numeric_input':
            case 'control_date_input':
            case 'control_time_input':
            case 'control_date_calendar':
            case 'control_list':
            case 'control_drop_down':
            case 'control_numeric_stepper':
            case 'control_mask_text_input':
            case 'control_password_input':
            case 'control_ranking':
                this.deattachInputs(control);
                break;
            case 'control_file_attachment':
                this.deattachFileAttachment(control);
                break;
            case 'control_button':
            case 'control_print_button':
            case 'control_page_button':
            case 'control_submit_button':
            case 'control_play_form_button':
            case 'control_play_report_button':
                this.deattachButtons(control);
                break;
            case 'control_image_input':
                this.deattachImageImport(control);
                break;
            case 'control_websignature':
                this.deattachWebSignature(control);
                break;
            case 'control_checkbox':
            case 'control_radio_button':
                this.deattachCheckboxes(control);
                break;
            case 'control_group':
                this.deattachGroups(control);
                break;
            case 'control_checkbox_group':
            case 'control_radio_button_group':
                this.deattachGroupCheckboxes(control);
                this.deattachGroups(control);
                break;
            case 'control_horizontal_separator':
            case 'control_vertical_separator':
                this.deattachSeparators(control);
                break;
            case 'control_table':
                this.deattachTables(control);
                break;
            default: break;
        }
    }

    deattachPage(control) {
        control.model.set('stylePictureSelect', control.resolveTheme(control.model.get('stylePictureSelect')), {silent: true});

        control.model.set('styleBGColor', control.resolveTheme(control.model.get('styleBGColor')), {silent: true});
        control.model.set('styleBGColorText', control.resolveTheme(control.model.get('styleBGColorText')), {silent: true});

        control.model.set('backgroundImageAssetId', control.resolveTheme(control.model.get('backgroundImageAssetId')), {silent: true});
        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});
    }

    deattachText(control) {
        control.model.set('font', control.resolveTheme(control.model.get('font')), {silent: true});
        control.model.set('fontFamily', control.resolveThemeFontProperty('fontFamily'), {silent: true});
        control.model.set('fontSize', control.resolveThemeFontProperty('fontSize'), {silent: true});
        control.model.set('textStyle', control.resolveThemeFontProperty('textStyle'), {silent: true});
        control.model.set('textWeight', control.resolveThemeFontProperty('textWeight'), {silent: true});
        control.model.set('styleColorText', control.resolveTheme(control.model.get('styleColorText')), {silent: true});
    }

    deattachInputs(control) {
        control.model.set('styleColorText', control.resolveTheme(control.model.get('styleColorText')), {silent: true});
        control.model.set('textColor', control.resolveTheme(control.model.get('textColor')), {silent: true});

        control.model.set('font', control.resolveTheme(control.model.get('font')), {silent: true});
        control.model.set('fontFamily', control.resolveThemeFontProperty('fontFamily'), {silent: true});
        control.model.set('fontSize', control.resolveThemeFontProperty('fontSize'), {silent: true});
        control.model.set('textStyle', control.resolveThemeFontProperty('textStyle'), {silent: true});
        control.model.set('textWeight', control.resolveThemeFontProperty('textWeight'), {silent: true});

        control.model.set('border', control.resolveTheme(control.model.get('border')), {silent: true});
        control.model.set('borderColor', control.resolveThemeBorderProperty('borderColor'), {silent: true});
        control.model.set('borderSize', control.resolveThemeBorderProperty('borderSize'), {silent: true});
        control.model.set('borderStyle', control.resolveThemeBorderProperty('borderStyle'), {silent: true});
        control.model.set('cornerRadius', control.resolveThemeBorderProperty('cornerRadius'), {silent: true});

        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});
        control.model.set('styleBGColorText', control.resolveTheme(control.model.get('styleBGColorText')), {silent: true});
    }

    deattachFileAttachment(control) {
        control.model.set('fontFamily', control.resolveThemeFontProperty('fontFamily'), {silent: true});
        control.model.set('fontSize', control.resolveThemeFontProperty('fontSize'), {silent: true});
        control.model.set('textStyle', control.resolveThemeFontProperty('textStyle'), {silent: true});
        control.model.set('textWeight', control.resolveThemeFontProperty('textWeight'), {silent: true});

        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});

        control.model.set('borderColor', control.resolveThemeBorderProperty('borderColor'), {silent: true});
        control.model.set('borderSize', control.resolveThemeBorderProperty('borderSize'), {silent: true});
        control.model.set('borderStyle', control.resolveThemeBorderProperty('borderStyle'), {silent: true});
        control.model.set('cornerRadius', control.resolveThemeBorderProperty('cornerRadius'), {silent: true});

        control.model.set('advancedBgColor', control.resolveTheme(control.model.get('advancedBgColor')), {silent: true});
        control.model.set('backgroundFromText', control.resolveTheme(control.model.get('backgroundFromText')), {silent: true});
        control.model.set('advancedBgGradientColor', control.resolveTheme(control.model.get('advancedBgGradientColor')), {silent: true});
        control.model.set('backgroundToText', control.resolveTheme(control.model.get('backgroundToText')), {silent: true});

        // Button Styles
        control.model.set('buttonStyleColorText', control.resolveTheme(control.model.get('buttonStyleColorText')), {silent: true});

        control.model.set('buttonFontFamily', control.resolveThemeFontProperty('buttonFontFamily'), {silent: true});
        control.model.set('buttonFontSize', control.resolveThemeFontProperty('buttonFontSize'), {silent: true});
        control.model.set('buttonTextWeight', control.resolveThemeFontProperty('buttonTextWeight'), {silent: true});
        control.model.set('buttonTextStyle', control.resolveThemeFontProperty('buttonTextStyle'), {silent: true});

        control.model.set('buttonTextColor', control.resolveTheme(control.model.get('buttonTextColor')), {silent: true});
        control.model.set('buttonBackgroundColor', control.resolveTheme(control.model.get('buttonBackgroundColor')), {silent: true});
        control.model.set('buttonBackgroundGradientColor', control.resolveTheme(control.model.get('buttonBackgroundGradientColor')), {silent: true});
        control.model.set('styleColorText', control.resolveTheme(control.model.get('styleColorText')), {silent: true});
        control.model.set('styleBGColorText', control.resolveTheme(control.model.get('styleBGColorText')), {silent: true});
    }

    deattachButtons(control) {
        control.model.set('buttonStyle', control.resolveTheme(control.model.get('buttonStyle')), {silent: true});
        control.model.set('styleColorText', control.resolveTheme(control.model.get('styleColorText')), {silent: true});
        control.model.set('styleColorTextDown', control.resolveTheme(control.model.get('styleColorTextDown')), {silent: true});
        control.model.set('styleColorTextOver', control.resolveTheme(control.model.get('styleColorTextOver')), {silent: true});

        control.model.set('font', control.resolveTheme(control.model.get('font')), {silent: true});
        control.model.set('fontFamily', control.resolveThemeFontProperty('fontFamily'), {silent: true});
        control.model.set('fontSize', control.resolveThemeFontProperty('fontSize'), {silent: true});
        control.model.set('textStyle', control.resolveThemeFontProperty('textStyle'), {silent: true});
        control.model.set('textWeight', control.resolveThemeFontProperty('textWeight'), {silent: true});

        control.model.set('border', control.resolveTheme(control.model.get('border')), {silent: true});
        control.model.set('borderColor', control.resolveThemeBorderProperty('borderColor'), {silent: true});
        control.model.set('borderSize', control.resolveThemeBorderProperty('borderSize'), {silent: true});
        control.model.set('borderStyle', control.resolveThemeBorderProperty('borderStyle'), {silent: true});
        control.model.set('cornerRadius', control.resolveThemeBorderProperty('cornerRadius'), {silent: true});

        control.model.set('advancedBgColor', control.resolveTheme(control.model.get('advancedBgColor')), {silent: true});
        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});
        control.model.set('advancedBgGradientColor', control.resolveTheme(control.model.get('advancedBgGradientColor')), {silent: true});
        control.model.set('advancedBgColorOver', control.resolveTheme(control.model.get('advancedBgColorOver')), {silent: true});
        control.model.set('advancedBgGradientColorOver', control.resolveTheme(control.model.get('advancedBgGradientColorOver')), {silent: true});
        control.model.set('advancedBgColorDown', control.resolveTheme(control.model.get('advancedBgColorDown')), {silent: true});
        control.model.set('advancedBgGradientColorDown', control.resolveTheme(control.model.get('advancedBgGradientColorDown')), {silent: true});
    }

    deattachWebSignature(control) {
        control.model.set('buttonTextColor', control.resolveTheme(control.model.get('buttonTextColor')), {silent: true});
        control.model.set('styleColorTextDown', control.resolveTheme(control.model.get('styleColorTextDown')), {silent: true});
        control.model.set('styleColorTextOver', control.resolveTheme(control.model.get('styleColorTextOver')), {silent: true});

        control.model.set('buttonFontFamily', control.resolveThemeFontProperty('buttonFontFamily'), {silent: true});
        control.model.set('buttonFontSize', control.resolveThemeFontProperty('buttonFontSize'), {silent: true});
        control.model.set('buttonTextWeight', control.resolveThemeFontProperty('buttonTextWeight'), {silent: true});
        control.model.set('buttonTextStyle', control.resolveThemeFontProperty('buttonTextStyle'), {silent: true});

        control.model.set('buttonBackgroundColor', control.resolveTheme(control.model.get('buttonBackgroundColor')), {silent: true});
        control.model.set('buttonBackgroundGradientColor', control.resolveTheme(control.model.get('buttonBackgroundGradientColor')), {silent: true});
        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});
        control.model.set('advancedBgGradientColor', control.resolveTheme(control.model.get('advancedBgGradientColor')), {silent: true});
        control.model.set('bgGradientColor', control.resolveTheme(control.model.get('bgGradientColor')), {silent: true});

    }

    deattachImageImport(control) {
        control.model.set('styleColorText', control.resolveTheme(control.model.get('styleColorText')), {silent: true});

        control.model.set('font', control.resolveTheme(control.model.get('font')), {silent: true});
        control.model.set('fontFamily', control.resolveThemeFontProperty('fontFamily'), {silent: true});
        control.model.set('fontSize', control.resolveThemeFontProperty('fontSize'), {silent: true});
        control.model.set('textStyle', control.resolveThemeFontProperty('textStyle'), {silent: true});
        control.model.set('textWeight', control.resolveThemeFontProperty('textWeight'), {silent: true});

        control.model.set('buttonTextColor', control.resolveTheme(control.model.get('buttonTextColor')), {silent: true});

        control.model.set('buttonFontFamily', control.resolveThemeFontProperty('buttonFontFamily'), {silent: true});
        control.model.set('buttonFontSize', control.resolveThemeFontProperty('buttonFontSize'), {silent: true});
        control.model.set('buttonTextWeight', control.resolveThemeFontProperty('buttonTextWeight'), {silent: true});
        control.model.set('buttonTextStyle', control.resolveThemeFontProperty('buttonTextStyle'), {silent: true});

        control.model.set('buttonBackgroundColor', control.resolveTheme(control.model.get('buttonBackgroundColor')), {silent: true});
        control.model.set('buttonBackgroundGradientColor', control.resolveTheme(control.model.get('buttonBackgroundGradientColor')), {silent: true});
        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});
        control.model.set('advancedBgGradientColor', control.resolveTheme(control.model.get('advancedBgGradientColor')), {silent: true});
    }

    deattachCheckboxes(control) {
        control.model.set('styleColorText', control.resolveTheme(control.model.get('styleColorText')), {silent: true});
        control.model.set('styleColorTextOver', control.resolveTheme(control.model.get('styleColorTextOver')), {silent: true});

        control.model.set('font', control.resolveTheme(control.model.get('font')), {silent: true});
        control.model.set('fontFamily', control.resolveThemeFontProperty('fontFamily'), {silent: true});
        control.model.set('fontSize', control.resolveThemeFontProperty('fontSize'), {silent: true});
        control.model.set('textStyle', control.resolveThemeFontProperty('textStyle'), {silent: true});
        control.model.set('textWeight', control.resolveThemeFontProperty('textWeight'), {silent: true});

        control.model.set('borderColor', control.resolveTheme(control.model.get('borderColor')), {silent: true});
        control.model.set('advancedBgColor', control.resolveTheme(control.model.get('advancedBgColor')), {silent: true});
        control.model.set('advancedBgGradientColor', control.resolveTheme(control.model.get('advancedBgGradientColor')), {silent: true});
    }

    deattachGroupCheckboxes(control) {
        try {
            Immutable.List(control.model.get('childList')).map(c => {
                c.set('styleColorText', control.resolveTheme(c.get('styleColorText')), {silent: true});
                c.set('styleColorTextOver', control.resolveTheme(c.get('styleColorTextOver')), {silent: true});

                c.set('font', control.resolveTheme(c.get('font')), {silent: true});
                c.set('fontFamily', control.resolveThemeFontProperty('fontFamily'), {silent: true});
                c.set('fontSize', control.resolveThemeFontProperty('fontSize'), {silent: true});
                c.set('textStyle', control.resolveThemeFontProperty('textStyle'), {silent: true});
                c.set('textWeight', control.resolveThemeFontProperty('textWeight'), {silent: true});
                c.set('borderColor', control.resolveTheme(c.get('borderColor')), {silent: true});
                c.set('backgroundColor', control.resolveTheme(c.get('backgroundColor')), {silent: true});
                c.set('advancedBgGradientColor', control.resolveTheme(c.get('advancedBgGradientColor')), {silent: true});
           });
        } catch (e) {
            console.log(e);
        }
    }

    deattachGroups(control) {
        control.model.set('border', control.resolveTheme(control.model.get('border')), {silent: true});
        control.model.set('borderColor', control.resolveThemeBorderProperty('borderColor'), {silent: true});
        control.model.set('borderSize', control.resolveThemeBorderProperty('borderSize'), {silent: true});
        control.model.set('borderStyle', control.resolveThemeBorderProperty('borderStyle'), {silent: true});
        control.model.set('cornerRadius', control.resolveThemeBorderProperty('cornerRadius'), {silent: true});

        control.model.set('titleColor', control.resolveTheme(control.model.get('titleColor')), {silent: true});
        control.model.set('titleBackgroundColor', control.resolveTheme(control.model.get('titleBackgroundColor')), {silent: true});

        control.model.set('titleFontFamily', control.resolveThemeFontProperty('titleFontFamily'), {silent: true});
        control.model.set('titleFontSize', control.resolveThemeFontProperty('titleFontSize'), {silent: true});
        control.model.set('titleTextStyle', control.resolveThemeFontProperty('titleTextStyle'), {silent: true});
        control.model.set('titleTextWeight', control.resolveThemeFontProperty('titleTextWeight'), {silent: true});

        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});
        control.model.set('backgroundImageAssetId', control.resolveTheme(control.model.get('backgroundImageAssetId')), {silent: true});
        control.model.set('styleBGColorText', control.resolveTheme(control.model.get('styleBGColorText')), {silent: true});
        control.model.set('bgImage', control.resolveTheme(control.model.get('bgImage')), {silent: true});
        control.model.set('transparentBackground', control.resolveTheme(control.model.get('transparentBackground')), {silent: true});
    }

    deattachSeparators(control) {
        control.model.set('lineColor', control.resolveTheme(control.model.get('lineColor')), {silent: true});
        if (control === 'control_vertical_separator') {
            control.model.set('width', control.resolveTheme(control.model.get('width')), {silent: true});
        } else {
            control.model.set('height', control.resolveTheme(control.model.get('height')), {silent: true});
        }
    }

    deattachTables(control) {
        control.model.set('styleHeaderColorText', control.resolveTheme(control.model.get('styleHeaderColorText')), {silent: true});
        control.model.set('headerBgColor', control.resolveTheme(control.model.get('headerBgColor')), {silent: true});
        control.model.set('headerBgColorGradient', control.resolveTheme(control.model.get('headerBgColorGradient')), {silent: true});
        control.model.set('rowBGColor', control.resolveTheme(control.model.get('rowBGColor')), {silent: true});
        control.model.set('rowBGColorGradient', control.resolveTheme(control.model.get('rowBGColorGradient')), {silent: true});
        control.model.set('backgroundColor', control.resolveTheme(control.model.get('backgroundColor')), {silent: true});
        control.model.set('headerTextColor', control.resolveTheme(control.model.get('headerTextColor')), {silent: true});
        control.model.set('styleHeaderColorText', control.resolveTheme(control.model.get('styleHeaderColorText')), {silent: true});
        control.model.set('headerFont', control.resolveTheme(control.model.get('headerFont')), {silent: true});
        control.model.set('headerFontFamily', control.resolveThemeHeaderFontProperty('headerFontFamily'), {silent: true});
        control.model.set('headerFontSize', control.resolveThemeHeaderFontProperty('headerFontSize'), {silent: true});
        control.model.set('headerTextStyle', control.resolveThemeHeaderFontProperty('headerTextStyle'), {silent: true});
        control.model.set('headerTextWeight', control.resolveThemeHeaderFontProperty('headerTextWeight'), {silent: true});
        control.model.set('border', control.resolveTheme(control.model.get('border')), {silent: true});
        control.model.set('borderColor', control.resolveThemeBorderProperty('borderColor'), {silent: true});
        control.model.set('borderSize', control.resolveThemeBorderProperty('borderSize'), {silent: true});
        control.model.set('borderStyle', control.resolveThemeBorderProperty('borderStyle'), {silent: true});
        control.model.set('cornerRadius', control.resolveThemeBorderProperty('cornerRadius'), {silent: true});
    }


}

const themeService = new ThemeService();
export default themeService;
